/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect, useState, useRef, useCallback } from "react";
// import IconButton from "@mui/material/IconButton";
// import UploadIcon from "@mui/icons-material/Upload";
import FeedGallery from "./FeedGallery";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Box, Divider, Stack, Typography, Grid, Modal, Backdrop, Fade, Tooltip } from "@mui/material";
import ImageCarousel from "../../components/ImageCarousel/ImageCarousel";
import socket from "../../configs/socket";
import socketConstants from "../../constants/socket";
import moment from "moment";
import {
  FacebookShareButton,
  LinkedinShareButton,
} from "react-share";
import { formatCurrency } from "../../helpers/formatter";
import { GET_IMAGE } from "../../helpers/images";
import SlowClap from "../../components/SlowClap/SlowClap";
import { ADD_REACT, DELETE_REACT } from "../../api/react";
import { REACTION_PROPERTY_TYPE } from "../../constants/reactions";
import { useDispatch } from "react-redux";
import { addComment, getJob } from "../../redux/jobs/actions";
import CommentList from "../../components/Comments/CommentList";
import { ADD_COMMENT, UPDATE_COMMENT, DELETE_COMMENT } from "../../api/comments";
import { UseIsAdmin, UseUserDetails } from "../../hooks/auth";
import { UseCompanyKpis } from "../../hooks/kpi";
import { UseCompanyLogo, UseCompanyColors } from "../../hooks/company";
import useMeasure from "react-use-measure";
import { isMobile } from "react-device-detect";
import SoftProfile from "../../components/ProfilePictures/SoftProfile";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  getFacebookShareable,
  getSocialUrl,
} from "../../components/Feed/socialImage";
import SoftBox from "../../components/SoftBox";
import SoftTypography from "../../components/SoftTypography";
import SoftButton from "../../components/SoftButton";
import { toast } from "react-hot-toast";
import {
  getHcpTagColor,
  resolveJobRoleTag,
} from "../../helpers/timelineEntry";
import { fontWeight, minWidth, textAlign } from "@mui/system";
import { DEFAULT_FEED_SETTINGS, shouldShowFeedKpiEntry } from "../../helpers/feedKpiSettings";
import { recomputeEntryPts, indexKpisById } from "../../helpers/kpiPoints";

const GOOGLE_MAP_EMBED_API = `https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_API_KEY}&zoom=13&q=`;

const { SOCKET_EVENT } = socketConstants;
const MOBILE_HEIGHT = "250px";
const DEFAULT_HEIGHT = "390px";

export default function FeedItem({ job, isModal, settings, rcAmount, rcPoints, refId, openComments }) {
  const dispatch = useDispatch();
  const { user, amount: jobTotal, metadata, comments } = job;
  const roleTag = resolveJobRoleTag(job);
  const [ref, { width }] = useMeasure();
  const [showGallery, setShowGallery] = useState(false);
  const location =
    metadata?.location || "9839 Echo Valley Rd NW, Bremerton, WA 98312, USA";
  const [labels, setLabels] = useState([]);
  const [points, setPoints] = useState(0);
  const [kpis, setKpis] = useState([]);
  const [isOwner, setIsOwner] = useState(false);
  const isAdmin = UseIsAdmin();
  const [url, setUrl] = useState("none");
  const [urlLinkedIn, setUrlLinkedIn] = useState("none");
  const [images, setImages] = useState([]);
  const [reacts, setReacts] = useState([]);
  const pendingReactAdds = useRef({});
  const [gallery, setGallery] = useState([]);
  const [toggleComment, setToggleComment] = useState(!!openComments);
  const [toggleShare, setToggleShare] = useState(false);
  const shareButtonFacebook = useRef(null);
  const shareButtonLinkedIn = useRef(null);
  const downloadButton = useRef(null);
  const currentUser = UseUserDetails();
  const companyKpis = UseCompanyKpis();
  const companyLogo = UseCompanyLogo();
  const { primaryColor } = UseCompanyColors();

  const appTheme = useTheme();
  const largeBp = useMediaQuery(appTheme.breakpoints.up("lg"));
  const miniBp = useMediaQuery(appTheme.breakpoints.up("mini"));
  const xLargeBp = useMediaQuery(appTheme.breakpoints.up("xl"));

  const height = isMobile ? MOBILE_HEIGHT : DEFAULT_HEIGHT;

  // Stable reference — this used to be redefined every render, which meant
  // the NOTIFY_REFETCH_JOB listener effect below (keyed on it) re-ran on
  // every render too.
  const refetchJob = useCallback((jobId) => {
    dispatch(getJob(jobId));
  }, [dispatch]);

  const onAddComment = async (jobId, senderId, content) => {
    const { data: comment } = await ADD_COMMENT({
      jobId,
      data: {
        userId: senderId,
        content,
        propertyModel: "Job",
      },
    });

    dispatch(addComment({ jobId, comment }));
    socket.emit(SOCKET_EVENT.REFRESH_JOB, { jobId });
    socket.emit(SOCKET_EVENT.POST_COMMENT, {
      sender: senderId,
      jobId,
      content,
    });
  };

  const onEditComment = async (commentId, content) => {
    await UPDATE_COMMENT(commentId, content);
    socket.emit(SOCKET_EVENT.REFRESH_JOB, { jobId: job._id });
    await refetchJob(job._id);
  };

  const onDeleteComment = async (commentId, jobId) => {
    await DELETE_COMMENT(commentId);
    socket.emit(SOCKET_EVENT.REFRESH_JOB, { jobId });
    await refetchJob(jobId);
  };

  const onReactToggle = async (
    propertyId,
    currentUserId,
    isActive,
    react,
    iconType,
    propertyModel,
  ) => {
    // Optimistic UI: reflect the tap instantly instead of waiting on the
    // ADD_REACT/DELETE_REACT round trip + full job refetch to paint.
    const jobId = job._id;
    if (isActive) {
      const tempId = `temp_${currentUserId}_${Date.now()}`;
      setReacts((prev) => [...(prev || []), { _id: tempId, users: [{ _id: currentUserId }] }]);
      if (propertyModel === REACTION_PROPERTY_TYPE.JOB) {
        socket.emit(SOCKET_EVENT.POST_SLOW_CLAP, {
          sender: currentUser._id,
          jobId: job._id,
        });
      } else if (propertyModel === REACTION_PROPERTY_TYPE.COMMENT) {
        socket.emit(SOCKET_EVENT.POST_COMMENT_LIKE, {
          sender: currentUser._id,
          commentId: propertyId,
          jobId: job._id,
        });
      }
      const addPromise = ADD_REACT({
        propertyId,
        data: {
          userId: currentUserId,
          propertyModel,
          iconType,
        },
      }).then(({ data: added }) => {
        setReacts((prev) => (prev || []).map((r) => (r._id === tempId ? added : r)));
        return added;
      });
      pendingReactAdds.current[tempId] = addPromise;
      try {
        await addPromise;
        socket.emit(SOCKET_EVENT.REFRESH_JOB, { jobId });
        dispatch(getJob(jobId));
      } catch (err) {
        setReacts((prev) => (prev || []).filter((r) => r._id !== tempId));
      } finally {
        delete pendingReactAdds.current[tempId];
      }
    } else {
      setReacts((prev) => (prev || []).filter((r) => r._id !== react._id));
      try {
        // If this reaction hasn't finished being created yet (rapid tap-off),
        // wait for the real id instead of deleting the temporary local one.
        const pendingAdd = pendingReactAdds.current[react._id];
        const realId = pendingAdd ? (await pendingAdd)._id : react._id;
        await DELETE_REACT(realId);
        socket.emit(SOCKET_EVENT.REFRESH_JOB, { jobId });
        dispatch(getJob(jobId));
      } catch (err) {
        setReacts((prev) => [...(prev || []), react]);
      }
    }
  };

  // Own effect, scoped only to job.reacts — the combined effect below re-runs
  // on any unrelated change (companyKpis, currentUser, rcAmount, ...), and
  // syncing `reacts` there stomped the optimistic "you clapped" state back to
  // whatever was still in Redux before the refetch landed, flashing the clap
  // button back to its unclapped color and then pink again a moment later.
  useEffect(() => {
    setReacts(job.reacts);
  }, [job.reacts]);

  useEffect(() => {
    // Grant owner status for actual user and admins
    setIsOwner(job.userId === currentUser._id || isAdmin);

    if (job.images && job.images.length) {
      setImages(job.images.map((key) => GET_IMAGE(key.src)));
      setLabels(job.images.map((key) => key.tag));
    } else {
      setImages([]);
      setLabels([]);
    }

    // Recompute each entry's pts using the same rule as the leaderboard
    // (amount × pointValue / pointScale, anchor metrics trust server pts) so
    // the +pts badge matches the breakdown row beneath it.
    //
    // Double-count guard: when we're going to add Revenue Credit from rcAmount,
    // skip any Revenue Credit row already inside job.kpis / job.claims. Without
    // this, the same RC contribution lands twice — once from the per-row reduce
    // and once from the rcAmount branch — yielding ~2× the right number.
    // companyKpis is null for a render right after login — guard the index.
    const groupKpisForPts = companyKpis?.[user?.groupId] || [];
    const kpiById = indexKpisById(groupKpisForPts);
    const revenueCreditKpi = groupKpisForPts.find((k) =>
      k?.title?.toLowerCase()?.includes("revenue"),
    );
    const usingRcAmount = rcAmount != null && !!revenueCreditKpi;
    const rcKpiId = revenueCreditKpi?._id;

    // Poster's entries only — the `kpis` virtual returns every EmployeeKpi
    // row referencing the job, including other players' rows and rows from
    // other workspaces' KPIs, which would inflate the badge (same rule as
    // FeedCard).
    const posterId = String(job.userId || user?._id || "");
    const jobKpis = [...(job.kpis || []), ...(job.claims || [])].filter(
      (k) => String(k?.ownerId || "") === posterId,
    );
    let total = 0;
    if (jobKpis.length) {
      total = jobKpis.reduce((prev, curr) => {
        if (usingRcAmount && curr?.kpiId === rcKpiId) return prev; // counted via rcAmount
        return prev + recomputeEntryPts(curr, kpiById[curr.kpiId]);
      }, 0);
    }
    if (usingRcAmount) {
      total += recomputeEntryPts({ amount: rcAmount }, revenueCreditKpi);
    } else if (rcPoints) {
      total += rcPoints;
    }
    setPoints(Math.floor(total));

    const kpiSummary = [];
    const groupKpis = companyKpis?.[user?.groupId];

    // Always map groupKpis to summary, whether there's a job score or not (if workspace is right)
    if (groupKpis && groupKpis.length > 0) {
      groupKpis.forEach((kpi) => {
        const scoreMatch = jobKpis.find((score) => score.kpiId === kpi._id);

        if (kpi.disabled !== true) {
          // Filter to exclude revenue KPIs
          if (kpi.direction >= 1 || scoreMatch) {
            // Display Positive KPIs always, Negative only if exists in job
            kpiSummary.push({
              kpiId: kpi._id,
              title: kpi.title,
              isActive: !!scoreMatch,
              ...(scoreMatch || {}),
            });
          }
        }
      });
    }

    setKpis(kpiSummary);
  }, [job, isAdmin, user?.groupId, currentUser, companyKpis, rcAmount, rcPoints]);

  useEffect(() => {
    // `refetchJob` was recreated every render and this effect's cleanup was
    // missing entirely, so a new listener stacked onto the shared socket on
    // every render without ever removing the old ones — a single broadcast
    // could end up firing dozens of concurrent getJob refetches for the same
    // job, racing and landing out of order (visible as the clap button
    // flickering between clapped/unclapped as stale responses won the race).
    const handleRefetch = (data) => {
      if (data.jobId === job._id) {
        refetchJob(job._id);
      }
    };
    socket.on(SOCKET_EVENT.NOTIFY_REFETCH_JOB, handleRefetch);
    return () => socket.off(SOCKET_EVENT.NOTIFY_REFETCH_JOB, handleRefetch);
  }, [job._id, refetchJob]);

  useEffect(() => {
    socket.emit(SOCKET_EVENT.JOIN_JOB, job._id);
  }, [job]);

  const getShareableUrl = async () => {
    const { _id, shareable, updatedAt } = job;
    // Return previously composed before & after image if there have been no changes in job data since
    if (shareable?.key && shareable.timestamp >= updatedAt) {
      return getSocialUrl(shareable.key);
    }
    // Else compose a new before & after image
    const shareableUrl = await getFacebookShareable(
      job._id,
      gallery,
      companyLogo,
      primaryColor,
    );
    dispatch(getJob(_id));
    return shareableUrl;
  };

  const onClick = async () => {
    if (url === "none") {
      try {
        const shareable = await getShareableUrl();
        setUrl(shareable);
        setTimeout(() => shareButtonFacebook.current?.click(), 250);
      } catch (err) {
        console.log("Shareable image error", err.response || err);
      }
    }
  };

  const onClickLinkedIn = async () => {
    if (urlLinkedIn === "none") {
      const shareable = await getShareableUrl();
      setUrlLinkedIn(shareable);
      setTimeout(() => shareButtonLinkedIn.current?.click(), 250);
    }
  };

  const onDownloadClick = async () => {
    const toastId = toast.loading("Preparing download ...");
    if (url === "none") {
      const shareable = await getShareableUrl();
      setUrl(shareable);
    }
    toast.success("Downloading ...", { id: toastId });
    setTimeout(() => downloadButton.current?.click(), 250);
  };

  // Set default settings if not provided
  if (!settings) {
    settings = { ...DEFAULT_FEED_SETTINGS };
  }

  const [lineItemsModal, setLineItemsModal] = useState(false);

  const handleCloseModal = () => setLineItemsModal(false);

  const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'url(.png), linear-gradient(156.05deg, rgba(12,12,13,0.5) 3.85%, rgba(12,12,13,0.65) 50.21%, rgba(12,12,13,0.51) 98.53%)',
    border: '1px solid #98A2B3',
    boxShadow: '12.2236px 12.2236px 24.4473px rgba(0, 0, 0, 0.2), inset -12.2236px -12.2236px 20.3727px rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
    maxWidth: { mini: "90%", xs: "90%", sm: "600px" },
    width: "100%",
    overflow: "visible",
    backdropFilter: 'blur(28.2614px)',
  };

  const styleModal2 = {
    padding: '1.25rem 1.25rem 0rem 1.25rem',
    width: "100%",
  };

  // Inside the "View Job" dialog the container is a fixed ~600px box
  // regardless of the actual monitor size, so the desktop-wide branches
  // below (keyed off screenWidth) must never fire there — only the real
  // full-page Feed route should ever see the true window width.
  const screenWidth = isModal ? 0 : window.innerWidth;

  return (
    <SoftBox
      sx={{
        width: "100%",
        padding: {
          mini: "1rem",
          sm: "1.5rem",
        },
        background: "white",
        boxShadow:
          "0px 0px 1px 0px rgba(0, 0, 0, 0.24), 0px 0px 3px 0px rgba(0, 0, 0, 0.04), 2px 4px 8px 0px rgba(0, 0, 0, 0.03), 0px 8px 16px 0px rgba(0, 0, 0, 0.02), 0px 12px 24px 0px rgba(0, 0, 0, 0.01)",
        borderRadius: "8px",
        marginBottom: "1rem",
      }}
    >
      <Modal
        open={lineItemsModal}
        onClose={handleCloseModal}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={lineItemsModal}>
          <SoftBox sx={styleModal}>
            <SoftBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={styleModal2}
            >
              <SoftTypography sx={{textFillColor: "#ffffff", fontSize: "20px!important", fontWeight: "400!important", marginLeft: "1rem" }}>
                Line Items
              </SoftTypography>
              <SoftButton
                color="white"
                onClick={handleCloseModal}
                sx={{
                  "& svg": { fontSize: "1.25rem !important" },
                  borderRadius: "50%",
                  minWidth: "max-content",
                  minHeight: "max-content",
                  padding: "0",
                  background: "none!important" 
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.263012" y="0.263012" width="23.3422" height="23.3422" rx="11.6711" stroke="white" strokeOpacity="0.2" strokeWidth="0.526024"/>
                  <path d="M15.9785 6.77246C16.2866 6.46447 16.7866 6.4645 17.0947 6.77246C17.4028 7.08056 17.4027 7.58051 17.0947 7.88867L13.0488 11.9336L17.0938 15.9785C17.4019 16.2867 17.4019 16.7866 17.0938 17.0947C16.7857 17.4027 16.2866 17.4026 15.9785 17.0947L11.9336 13.0498L7.88965 17.0947C7.58152 17.4029 7.08156 17.4029 6.77344 17.0947C6.46537 16.7866 6.46533 16.2866 6.77344 15.9785L10.8174 11.9336L6.77246 7.88867C6.46465 7.5805 6.46445 7.08051 6.77246 6.77246C7.0805 6.4644 7.58052 6.46458 7.88867 6.77246L11.9336 10.8174L15.9785 6.77246Z" fill="white"/>
                </svg>
              </SoftButton>
            </SoftBox>
            <SoftBox sx={{padding: '1.25rem 1.75rem 1.75rem 1.75rem', minHeight: "350px"}}>
                <SoftTypography sx={{fontSize: "14px", lineHeight: "120%", color: "#FFFFFF", marginBottom: "0rem", textAlign: "center"}}>
                  These are the service details included in this job.
                </SoftTypography>
                <SoftTypography sx={{fontSize: "14px", lineHeight: "120%", color: "#FFFFFF", marginBottom: "2rem", textAlign: "center"}}>
                  Review the breakdown below to see what was completed and billed.
                </SoftTypography>
                {Array.isArray(job.lineItems) && job.lineItems.filter(item => item.kind === "labor").length > 0 ? (
                  job.lineItems
                    .filter(item => item.kind === "labor" && item.amount > 0)
                    .sort((a, b) => (Number(b.amount) || 0) - (Number(a.amount) || 0))
                    .map((item, idx) => (
                      <SoftBox
                        display="flex"
                        alignItems="center"
                        sx={{
                          background: "rgba(255, 255, 255, 0.2)",
                          borderRadius: "8px",
                          padding: "1rem",
                          marginBottom: "0.5rem",
                          justifyContent: "space-between",
                        }}
                      >
                        <SoftTypography
                          sx={{
                            fontSize: "14px",
                            lineHeight: "18px",
                            color: "#FFFFFF",
                            flex: 1,
                            textAlign: "left",
                          }}
                        >
                          {item.name}
                        </SoftTypography>
                        <SoftTypography
                          sx={{
                            minWidth: "100px",
                            fontSize: "16px",
                            lineHeight: "20px",
                            color: "#FFFFFF",
                            textAlign: "right",
                            fontWeight: 700
                          }}
                        >
                          ${item.amount}
                        </SoftTypography>
                      </SoftBox>
                    ))
                ) : null}
            </SoftBox>
          </SoftBox>
        </Fade>
      </Modal>
      <Grid container spacing={2}>
        <Grid item mini={12} md={isModal ? 12 : 8} lg={isModal ? 12 : 8}>
          <SoftBox sx={{ display: { mini: "none", md: "flex" }, justifyContent: "space-between" }}>
            <SoftBox
              className="flex gap-x-[1rem]"
              sx={{
                display: "flex",
                gapX: "1rem",
                flexDirection: { mini: "column", md: "row" },
              }}
            >
              <SoftBox
                sx={{
                  display: screenWidth > 1024 ? "flex" : "none",
                  alignItems: "center",
                }}
              >
                <SoftBox sx={{
                  boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
                  borderRadius: "50%",
                  padding: "0px !important",
                }}>
                  <SoftProfile
                    src={user.image}
                    size={largeBp ? "xxl" : "xl"}
                    name={user.firstName}
                  />
                </SoftBox>
              </SoftBox>
              <SoftBox>
                <SoftBox sx={{ display: screenWidth > 1024 ? "block" : "none" }}>
                  <SoftBox display="flex" gap="1rem" justifyContent="between" alignItems="center" mt={1}>
                    <SoftTypography variant="h4" color="black" sx={{ fontSize: { lg: "26px", md: "22px" } }}>
                      {user.firstName} {user.lastName}
                    </SoftTypography>
                    {roleTag ? (
                      <SoftBox
                        key={roleTag}
                        sx={{
                          borderRadius: "6px",
                          width: "max-content",
                          padding: "4px 8px",
                          backgroundColor: getHcpTagColor(roleTag),
                          display: { mini: "none", md: "block" },
                        }}
                      >
                        <SoftTypography
                          sx={{
                            color: "primary.contrastText",
                            textTransform: "capitalize",
                            fontSize: "14px",
                          }}
                        >
                          {roleTag}
                        </SoftTypography>
                      </SoftBox>
                    ) : (
                      <SoftBox
                        sx={{
                          borderRadius: "6px",
                          width: "max-content",
                          padding: "4px 8px",
                          backgroundColor: "#E8ECF3",
                          display: { mini: "none", md: "block" },
                        }}
                      >
                        <SoftTypography
                          sx={{
                            color: "#6B7388",
                            fontSize: "14px",
                            fontWeight: 600,
                          }}
                        >
                          Not Tagged
                        </SoftTypography>
                      </SoftBox>
                    )}
                  </SoftBox>
                </SoftBox>
                <SoftBox display="flex" gap="10px" justifyContent="between" alignItems="center" mt={1}>
                  <SoftBox
                    bgColor="white"
                    sx={{
                      borderRadius: "6px",
                      width: "max-content",
                      marginBottom: "0.5rem",
                      padding: "4px 8px",
                      display: screenWidth > 1024 ? "block" : "none",
                      border: "1px solid #D9DEE7",
                    }}
                  >
                    <SoftTypography
                      variant="subtitle2"
                      sx={{
                        color: "#000!important",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      {points} points
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>

            <SoftBox
              bgColor="light"
              sx={{
                borderRadius: "5px",
                width: "max-content",
                padding: "4px 10px",
                height: "max-content",
                alignItems: "center",
                justifyContent: "center",
                display: screenWidth > 1024 ? "block" : "none",
              }}
            >
              <SoftTypography variant="caption" color="black" fontSize="14px">
                {moment(job.extRefDate).format("ddd | MMM Do YYYY")}
              </SoftTypography>
            </SoftBox>

            <SoftBox
              sx={{
                alignItems: "end",
                flexDirection: "column",
                gap: "10px",
                display: { mini: "flex", md: "none" },
              }}
            >
              <SoftBox
                bgColor="light"
                sx={{
                  borderRadius: "5px",
                  width: "max-content",
                  padding: "4px 10px",
                  height: "max-content",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <SoftTypography variant="caption" color="black">
                  {moment(job.extRefDate).format("ddd | MMM Do YYYY")}
                </SoftTypography>
              </SoftBox>
              <SoftBox
                bgColor="primary"
                sx={{
                  borderRadius: "6px",
                  width: "max-content",
                  marginBottom: "0.5rem",
                  padding: "8px 12px",
                }}
              >
                <SoftTypography
                  variant="subtitle2"
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  {points} points
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </SoftBox>

          <SoftBox sx={{ display: screenWidth > 1024 ? "none" : "block" }}>
            <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" gap="12px">
              <SoftBox display="flex" gap="10px" alignItems="center" sx={{ minWidth: 0 }}>
                <SoftBox
                  sx={{
                    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
                    borderRadius: "50%",
                    flexShrink: 0,
                  }}
                >
                  <SoftProfile
                    src={user.image}
                    size="lg"
                    name={user.firstName}
                  />
                </SoftBox>
                <SoftBox sx={{ minWidth: 0 }}>
                  <SoftTypography
                    color="black"
                    sx={{
                      fontSize: "16px",
                      fontWeight: 600,
                      lineHeight: "120%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {user.firstName} {user.lastName}
                  </SoftTypography>
                  <SoftBox
                    bgColor="white"
                    sx={{
                      marginTop: "6px",
                      borderRadius: "6px",
                      width: "max-content",
                      padding: "4px 8px",
                      border: "1px solid #D9DEE7",
                    }}
                  >
                    <SoftTypography
                      variant="subtitle2"
                      sx={{
                        color: "#000!important",
                        fontWeight: 600,
                        fontSize: "13px",
                        lineHeight: 1,
                      }}
                    >
                      {points} points
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
              {/* Role tag + date always right-aligned in their own column, regardless
                  of exact viewport width — previously this flipped to flex-start below
                  1024px, leaving the pill and date chip stranded on the left. */}
              <SoftBox display="flex" flexDirection="column" alignItems="flex-end" gap="6px" sx={{ flexShrink: 0 }}>
                {roleTag ? (
                  <SoftBox
                    key={roleTag}
                    sx={{
                      borderRadius: "6px",
                      width: "max-content",
                      padding: "4px 8px",
                      backgroundColor: getHcpTagColor(roleTag),
                    }}
                  >
                    <SoftTypography
                      sx={{
                        color: "primary.contrastText",
                        textTransform: "capitalize",
                        fontSize: "12px",
                        fontWeight: 600,
                        lineHeight: 1,
                      }}
                    >
                      {roleTag === "lead (with assistant)" ? "lead w/ asst" : roleTag}
                    </SoftTypography>
                  </SoftBox>
                ) : (
                  <SoftBox
                    sx={{
                      borderRadius: "6px",
                      width: "max-content",
                      padding: "4px 8px",
                      backgroundColor: "#E8ECF3",
                    }}
                  >
                    <SoftTypography
                      sx={{
                        color: "#6B7388",
                        fontSize: "12px",
                        fontWeight: 600,
                        lineHeight: 1,
                      }}
                    >
                      Not Tagged
                    </SoftTypography>
                  </SoftBox>
                )}
                <SoftBox
                  bgColor="light"
                  sx={{
                    borderRadius: "6px",
                    width: "max-content",
                    padding: "4px 8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <SoftTypography variant="caption" color="black" sx={{ fontSize: "11px", fontWeight: 600, whiteSpace: "nowrap" }}>
                    {moment(job.extRefDate).format("MMM Do YYYY")}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>
          <Divider sx={{ marginBottom: 0, marginTop: 2 }} />
          <SoftBox 
          sx={{
            padding: "1rem",
            display: "flex",
            alignItems: screenWidth === 1024 ? "flex-start" : "center",
            justifyContent: "space-between",
          }}
          >
            <SoftBox>
              {settings.customerName && (
                <SoftBox display="flex" gap="0.75rem" justifyContent="between" alignItems="center" width="100%">
                  <SoftTypography variant={largeBp ? "h4" : "h5"} color="black"
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "120%",
                    color: "#667085"
                  }}>
                   Customer Name
                  </SoftTypography>
                  <SoftBox sx={{
                    background: "#F8FBFD",
                    border: "1px solid rgba(0, 0, 0, 0.05)",
                    borderRadius: "5px",
                    padding: "4px 8px",
                  }}>
                    <SoftTypography variant={largeBp ? "h4" : "h5"} color="black"
                    sx={{
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "120%",
                      color: "#344054"
                    }}>
                      {metadata.customerName}
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              )}
              {settings.service && (
                <SoftBox display="flex" gap="0.75rem" justifyContent="between" alignItems="center" width="100%" mt={2}>
                  <SoftTypography variant={largeBp ? "h4" : "h5"} color="black"
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "120%",
                    color: "#667085"
                  }}>
                    Service
                  </SoftTypography>
                  <SoftBox display="flex" justifyContent="between" alignItems="center" width="100%">
                    <SoftBox sx={{
                      background: "#F8FBFD",
                      border: "1px solid rgba(0, 0, 0, 0.05)",
                      borderRadius: "5px",
                      padding: "4px 8px",
                    }}>
                      <SoftTypography
                        variant={largeBp ? "h5" : "h6"}
                      sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "120%",
                        color: "#344054"
                      }}>
                        {metadata.title || metadata.description}
                      </SoftTypography>
                    </SoftBox>
                    <Tooltip
                      title={<span>View Line Items</span>}
                      arrow
                      placement="top"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#404040",
                            color: "#fff",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#404040",
                          },
                        },
                      }}
                      style={{ cursor: "pointer!important", marginLeft: 10 }}
                      onClick={() => setLineItemsModal(true)}
                    >
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.5 12C6.36739 12 6.24021 11.9473 6.14645 11.8536C6.05268 11.7598 6 11.6326 6 11.5C6 11.3674 6.05268 11.2402 6.14645 11.1464C6.24021 11.0527 6.36739 11 6.5 11H13.5C13.6326 11 13.7598 11.0527 13.8536 11.1464C13.9473 11.2402 14 11.3674 14 11.5C14 11.6326 13.9473 11.7598 13.8536 11.8536C13.7598 11.9473 13.6326 12 13.5 12H6.5ZM6.5 15C6.36739 15 6.24021 14.9473 6.14645 14.8536C6.05268 14.7598 6 14.6326 6 14.5C6 14.3674 6.05268 14.2402 6.14645 14.1464C6.24021 14.0527 6.36739 14 6.5 14H13.5C13.6326 14 13.7598 14.0527 13.8536 14.1464C13.9473 14.2402 14 14.3674 14 14.5C14 14.6326 13.9473 14.7598 13.8536 14.8536C13.7598 14.9473 13.6326 15 13.5 15H6.5Z" fill="#667085"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M11.185 1H4.5C4.10218 1 3.72064 1.15804 3.43934 1.43934C3.15804 1.72064 3 2.10218 3 2.5V17.5C3 17.8978 3.15804 18.2794 3.43934 18.5607C3.72064 18.842 4.10218 19 4.5 19H15.5C15.8978 19 16.2794 18.842 16.5607 18.5607C16.842 18.2794 17 17.8978 17 17.5V7.202C16.9999 6.82647 16.859 6.46464 16.605 6.188L12.291 1.486C12.1504 1.33275 11.9795 1.2104 11.7891 1.12673C11.5987 1.04307 11.393 0.99991 11.185 1ZM4 2.5C4 2.36739 4.05268 2.24022 4.14645 2.14645C4.24021 2.05268 4.36739 2 4.5 2H11.185C11.2544 1.99992 11.323 2.01429 11.3865 2.04218C11.4501 2.07007 11.5071 2.11087 11.554 2.162L15.868 6.864C15.9528 6.95616 15.9999 7.07678 16 7.202V17.5C16 17.6326 15.9473 17.7598 15.8536 17.8536C15.7598 17.9473 15.6326 18 15.5 18H4.5C4.36739 18 4.24021 17.9473 4.14645 17.8536C4.05268 17.7598 4 17.6326 4 17.5V2.5Z" fill="#667085"/>
                        <path d="M11 7H16.5C16.6326 7 16.7598 7.05268 16.8536 7.14645C16.9473 7.24021 17 7.36739 17 7.5C17 7.63261 16.9473 7.75979 16.8536 7.85355C16.7598 7.94732 16.6326 8 16.5 8H10.5C10.3674 8 10.2402 7.94732 10.1464 7.85355C10.0527 7.75979 10 7.63261 10 7.5V1.5C10 1.36739 10.0527 1.24021 10.1464 1.14645C10.2402 1.05268 10.3674 1 10.5 1C10.6326 1 10.7598 1.05268 10.8536 1.14645C10.9473 1.24021 11 1.36739 11 1.5V7Z" fill="#667085"/>
                      </svg>
                    </Tooltip>
                  </SoftBox>
                </SoftBox>
              )}
              {settings.address && (
                <SoftBox display="flex" gap="0.75rem" justifyContent="between" alignItems="center" width="100%" mt={2}>
                  <SoftTypography variant={largeBp ? "h4" : "h5"} color="black"
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "120%",
                    color: "#667085"
                  }}>
                    Address
                  </SoftTypography>
                  <SoftBox sx={{
                    background: "#F8FBFD",
                    border: "1px solid rgba(0, 0, 0, 0.05)",
                    borderRadius: "5px",
                    padding: "4px 8px",
                    maxWidth: screenWidth > 1024 ? "250px" : null,
                  }}>
                    <SoftTypography
                      variant={largeBp ? "h5" : "h6"}
                    sx={{
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "120%",
                      color: "#344054"
                    }}>
                      {location}
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              )}
            </SoftBox>
            <SoftBox
              sx={{
                display:
                  (screenWidth > 1024 && "flex") ||
                  (screenWidth === 1024 && "block") ||
                  "none",
                alignItems: screenWidth > 1024 ? "center" : undefined,
                gap: screenWidth > 1024 ? "1rem" : undefined,
                alignSelf: "stretch",
              }}
            >
              {settings.jobTotal && (
                <SoftBox
                  sx={{
                    display: "flex",
                    padding: screenWidth === 1024 ? "0.25rem 0.25rem 0.25rem 1rem" : "1rem",
                    flexDirection: "column",
                    alignItems: "start",
                    textAlign: "center",
                    gap: "10px",
                    flex: "1 0 0",
                    borderRadius: "8px",
                    background: "linear-gradient(90deg, rgba(28, 132, 207, 0.04) 0%, rgba(28, 132, 207, 0) 100%)",
                    minWidth: "159px",
                    border: "2px solid #1C84CF1A",
                    marginBottom: screenWidth === 1024 ? "0.25rem" : 0,
                  }}
                >
                  <SoftTypography
                    sx={{ 
                      fontSize: "14px",
                      color: "#667085",
                    }}
                  >
                    Job Total
                  </SoftTypography>
                  <SoftTypography color="black"
                  sx={{
                    fontSize: screenWidth === 1024 ? "18px" : "24px",
                    fontWeight: 600,
                    lineHeight: "120%",
                    color: "#667085",
                  }}>
                    {formatCurrency(jobTotal || metadata.total)}
                  </SoftTypography>
                </SoftBox>
              )}
              {settings.jobTime && (
                <SoftBox
                  sx={{
                    display: "flex",
                    padding: screenWidth === 1024 ? "0.25rem 0.25rem 0.25rem 1rem" : "1rem",
                    flexDirection: "column",
                    alignItems: "start",
                    textAlign: "center",
                    gap: "10px",
                    flex: "1 0 0",
                    borderRadius: "8px",
                    background: "linear-gradient(90deg, rgba(28, 132, 207, 0.04) 0%, rgba(28, 132, 207, 0) 100%)",
                    minWidth: "159px",
                    border: "2px solid #1C84CF1A",
                  }}
                >
                  <SoftTypography
                    sx={{ 
                      fontSize: "14px",
                      color: "#667085",
                    }}
                  >
                    Time
                  </SoftTypography>
                  <SoftTypography color="black"
                  sx={{
                    fontSize: screenWidth === 1024 ? "18px" : "24px",
                    fontWeight: 600,
                    lineHeight: "120%",
                    color: "#667085",
                  }}>
                    {metadata.duration != null
                      ? new Date(metadata.duration * 1000).toISOString().substring(11, 16)
                      : "—"}
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
          </SoftBox>
          <SoftBox sx={{ display: screenWidth >= 1024 ? "none" : "block" }}>
            <Divider sx={{ marginBottom: 2, marginTop: 0 }} />
            <Grid container spacing={2} mb={2}>
              {settings.jobTotal && (
                <Grid item mini={6}>
                  <SoftBox
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "8px",
                      gap: { mini: "6px", lg: "10px" },
                      flex: "1 0 0",
                      borderRadius: "8px",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: "rgba(0, 0, 0, 0.05)",
                      background: "#F9FAFB",
                    }}
                  >
                    <SoftBox mt={-0.75}>
                      <SoftTypography
                        sx={{ 
                          fontSize: "10px",
                          color: "#667085",
                        }}
                      >
                        Job Total
                      </SoftTypography>
                      <SoftTypography color="black"
                      sx={{
                        fontSize: "16px",
                        fontWeight: 800,
                        lineHeight: "100%",
                        color: "#000000",
                      }}>
                        {formatCurrency(jobTotal || metadata.total)}
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </Grid>
              )}
              {settings.jobTime && (
                <Grid item mini={6}>
                  <SoftBox
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "8px",
                      gap: { mini: "6px", lg: "10px" },
                      flex: "1 0 0",
                      borderRadius: "8px",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: "rgba(0, 0, 0, 0.05)",
                      background: "#F9FAFB",
                    }}
                  >
                    <SoftBox mt={-0.75}>
                      <SoftTypography
                        sx={{ 
                          fontSize: "10px",
                          color: "#667085",
                        }}
                      >
                        Time
                      </SoftTypography>
                      <SoftTypography color="black"
                      sx={{
                        fontSize: "16px",
                        fontWeight: 800,
                        lineHeight: "100%",
                        color: "#000000",
                      }}>
                        {metadata.duration != null
                          ? new Date(metadata.duration * 1000).toISOString().substring(11, 16)
                          : "—"}
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </Grid>
              )}
            </Grid>
          </SoftBox>

          <Divider sx={{ marginBottom: 2, marginTop: 0 }} />
          <SoftBox sx={{ display: screenWidth > 1024 ? "none" : "block" }}>
            <Grid container spacing={2} mb={2}>
              {kpis.length ? (
                kpis
                  .filter((kpi) => shouldShowFeedKpiEntry({ _id: kpi.kpiId, title: kpi.title }, settings))
                  .map((kpi) => {
                    return (
                      <Grid item mini={4}>
                        <SoftBox
                          key={kpi.title}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "8px",
                            gap: { mini: "6px", lg: "10px" },
                            flex: "1 0 0",
                            borderRadius: "8px",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderColor: "rgba(0, 0, 0, 0.05)",
                            background: "#F9FAFB",
                          }}
                        >
                          <SoftBox display="flex" gap="1rem" justifyContent="between" alignItems="center">
                            <SoftTypography
                              variant={largeBp ? "subtitle2" : "button"}
                              sx={{ textTransform: "capitalize", fontSize: "14px", lineHeight: "120%", color: "#3D3D3F", width: "50%" }}
                            >
                              {kpi.title}
                            </SoftTypography>
                            <SoftBox sx={{padding: "8px", width: "50%", backgroundColor: "#fff", borderRadius: "6px", border: "1px solid rgba(0, 0, 0, 0.05)", textAlign: "center"}}>
                              <SoftTypography
                                variant={largeBp ? "h5" : "h6"}
                                color="black"
                                sx={{ fontSize: "14px", lineHeight: "120%", color: "#000000", fontWeight: 600 }}
                              >
                                {kpi.title.toLowerCase() === "revenue credit"
                                  ? `$${rcAmount ?? kpi.amount ?? 0}`
                                  : kpi.amount || 0}
                              </SoftTypography>
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                      </Grid>
                    );
                  })
              ) : null}
            </Grid>
          </SoftBox>
          
          <SoftBox
            sx={{
              display: screenWidth > 1024 ? "flex" : "none",
              paddingBottom: "0px",
              alignItems: "flex-start",
              gap: "10px",
              alignSelf: "stretch",
            }}
            mb={2}
          >
            {kpis.length ? (
              kpis
                .filter((kpi) => shouldShowFeedKpiEntry({ _id: kpi.kpiId, title: kpi.title }, settings))
                .map((kpi) => {
                  return (
                    <SoftBox
                      key={kpi.title}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "8px",
                        gap: { mini: "6px", lg: "10px" },
                        flex: "1 0 0",
                        borderRadius: "8px",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderColor: "rgba(0, 0, 0, 0.05)",
                        background: "#F9FAFB",
                      }}
                    >
                      <SoftBox display="flex" gap="2rem" justifyContent="between" alignItems="center">
                        <SoftTypography
                          variant={largeBp ? "subtitle2" : "button"}
                          sx={{ textTransform: "capitalize", fontSize: "16px", lineHeight: "120%", color: "#3D3D3F", width: "50%" }}
                        >
                          {kpi.title}
                        </SoftTypography>
                        <SoftBox sx={{padding: "8px", width: "50%", backgroundColor: "#fff", borderRadius: "6px", border: "1px solid rgba(0, 0, 0, 0.05)", textAlign: "center"}}>
                          <SoftTypography
                            variant={largeBp ? "h5" : "h6"}
                            color="black"
                            sx={{ fontSize: "16px", lineHeight: "120%", color: "#000000", fontWeight: 600 }}
                          >
                            {kpi.title.toLowerCase() === "revenue credit"
                              ? `$${rcAmount ?? kpi.amount ?? 0}`
                              : kpi.amount || 0}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                  );
                })
            ) : (
              <SoftTypography
                color="black"
                variant="h6"
                sx={{ textAlign: "center", width: "100%" }}
              >
                REGISTER [{user.firstName.toUpperCase()}{" "}
                {user.lastName.toUpperCase()}] TO A WORKSPACE
              </SoftTypography>
            )}
          </SoftBox>

          <SoftBox
            mt={2}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              alignSelf: "stretch",
            }}
          >
            <SoftBox
              sx={{
                display: "flex",
                gap: "0.25rem",
                alignItems: "center",
              }}
            >
              <SlowClap
                jobId={job._id}
                currentUserId={currentUser._id}
                reacts={reacts}
                onToggle={onReactToggle}
                showDetails={false}
              />

              <SoftBox
                sx={{ display: "flex", gap: "6px", alignItems: "center", 
                ...(comments.length > 0 || toggleComment && { background: "#F4F4F4", borderRadius: "8px", padding: "0.15rem 0.5rem !important", marginBottom: "0.5rem !important", marginTop: "0.5rem !important" })}}
              >
                <SoftTypography variant="h6" color="black" sx={{ fontSize: "14px" }}>
                  {comments.length}
                </SoftTypography>
                <SoftButton
                  type="button"
                  color="primary"
                  variant="text"
                  sx={{
                    minWidth: "max-content",
                    minHeight: "max-content",
                    borderRadius: "50%",
                    padding: 0,
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setToggleComment(!toggleComment)}>
                    <path d="M15.75 11.25C15.75 11.6478 15.592 12.0294 15.3107 12.3107C15.0294 12.592 14.6478 12.75 14.25 12.75H5.25L2.25 15.75V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H14.25C14.6478 2.25 15.0294 2.40804 15.3107 2.68934C15.592 2.97064 15.75 3.35218 15.75 3.75V11.25Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </SoftButton>
              </SoftBox>
            </SoftBox>
            <SoftBox sx={{ display: "flex", gap: "4px", alignItems: "center" }}>
              <SoftTypography
                variant={largeBp ? "body2" : "button"}
                sx={{
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "14px",
                  lineHeight: "120%",
                  color: "rgba(0, 0, 0, 0.6)",
                  marginBottom: "-0.25rem",
                  marginRight: "0.5rem",
                }}
              >
                Share
              </SoftTypography>
              <LinkedinShareButton
                ref={shareButtonLinkedIn}
                openShareDialogOnClick={urlLinkedIn !== "none"}
                url={urlLinkedIn}
                onClick={(!gallery.length || !isOwner) && isAdmin ? undefined : onClickLinkedIn}
                style={{ marginRight: "0.25rem", cursor: "pointer" }}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_249_17789)">
                  <path d="M18.125 0.468822H1.875C1.5063 0.46507 1.15117 0.607735 0.887529 0.865514C0.623892 1.12329 0.473283 1.47513 0.46875 1.84382V18.1594C0.474103 18.5276 0.625072 18.8786 0.88862 19.1357C1.15217 19.3928 1.50683 19.5351 1.875 19.5313H18.125C18.4937 19.5342 18.8486 19.3911 19.1121 19.1332C19.3756 18.8752 19.5263 18.5235 19.5312 18.1548V1.83913C19.5247 1.47152 19.3733 1.12136 19.1099 0.864769C18.8466 0.608173 18.4927 0.465881 18.125 0.468822Z" fill="#0076B2"/>
                  <path d="M3.29043 7.61401H6.12012V16.7187H3.29043V7.61401ZM4.70606 3.08276C5.03061 3.08276 5.34787 3.17902 5.6177 3.35937C5.88753 3.53971 6.09782 3.79603 6.22194 4.09591C6.34607 4.39579 6.37847 4.72574 6.31504 5.04403C6.25161 5.36233 6.0952 5.65466 5.8656 5.88404C5.636 6.11342 5.34352 6.26955 5.02517 6.33268C4.70681 6.39581 4.37689 6.36309 4.07713 6.23868C3.77737 6.11426 3.52125 5.90374 3.34117 5.63373C3.16108 5.36373 3.06512 5.04638 3.06543 4.72183C3.06584 4.28698 3.23888 3.87008 3.54651 3.56274C3.85414 3.2554 4.27121 3.08276 4.70606 3.08276ZM7.89512 7.61401H10.6076V8.86401H10.6451C11.0232 8.14839 11.9451 7.3937 13.3217 7.3937C16.1873 7.38745 16.7186 9.27339 16.7186 11.7187V16.7187H13.8889V12.289C13.8889 11.2343 13.8701 9.87651 12.4186 9.87651C10.967 9.87651 10.7201 11.0265 10.7201 12.2203V16.7187H7.89512V7.61401Z" fill="white"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_249_17789">
                  <rect width="20" height="20" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
              </LinkedinShareButton>
              <FacebookShareButton
                ref={shareButtonFacebook}
                openShareDialogOnClick={url !== "none"}
                url={url}
                onClick={(!gallery.length || !isOwner) && isAdmin ? undefined : onClick}
                style={{ marginRight: "0.25rem", cursor: "pointer" }}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_249_17799)">
                  <path d="M20 10C20 4.47719 15.5228 0 10 0C4.47719 0 0 4.47719 0 10C0 14.9913 3.65687 19.1284 8.4375 19.8785V12.8906H5.89844V10H8.4375V7.79688C8.4375 5.29063 9.93047 3.90625 12.2147 3.90625C13.3088 3.90625 14.4531 4.10156 14.4531 4.10156V6.5625H13.1922C11.9499 6.5625 11.5625 7.33336 11.5625 8.12422V10H14.3359L13.8926 12.8906H11.5625V19.8785C16.3431 19.1284 20 14.9913 20 10Z" fill="#1877F2"/>
                  <path d="M13.8926 12.8906L14.3359 10H11.5625V8.12422C11.5625 7.33328 11.9499 6.5625 13.1922 6.5625H14.4531V4.10156C14.4531 4.10156 13.3088 3.90625 12.2146 3.90625C9.93047 3.90625 8.4375 5.29063 8.4375 7.79688V10H5.89844V12.8906H8.4375V19.8785C8.95439 19.9595 9.4768 20.0001 10 20C10.5232 20.0001 11.0456 19.9595 11.5625 19.8785V12.8906H13.8926Z" fill="white"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_249_17799">
                  <rect width="20" height="20" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
              </FacebookShareButton>
              <SoftButton
                iconOnly={true}
                size="small"
                sx={{
                  background: "none !important",
                  padding: "0px !important",
                  border: "none !important",
                  boxShadow: "none !important",
                  outline: "none !important",
                  "&:hover": {
                    background: "none !important",
                  },
                }}
                onClick={!gallery.length || !isOwner ? undefined : onDownloadClick}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="20" height="20" rx="3.33333" fill="#F9FAFB"/>
                  <rect x="0.208333" y="0.208333" width="19.5833" height="19.5833" rx="3.125" stroke="#98A2B3" strokeOpacity="0.2" strokeWidth="0.416667"/>
                  <path d="M9.99935 12.3834C9.91046 12.3834 9.82713 12.3696 9.74935 12.342C9.67157 12.3145 9.59935 12.2671 9.53268 12.2L7.13268 9.80002C6.99935 9.66669 6.93535 9.51113 6.94068 9.33336C6.94602 9.15558 7.01002 9.00002 7.13268 8.86669C7.26602 8.73336 7.42446 8.66402 7.60802 8.65869C7.79157 8.65336 7.94979 8.71713 8.08268 8.85002L9.33268 10.1V5.33336C9.33268 5.14447 9.39668 4.98624 9.52468 4.85869C9.65268 4.73113 9.8109 4.66713 9.99935 4.66669C10.1878 4.66624 10.3462 4.73024 10.4747 4.85869C10.6031 4.98713 10.6669 5.14536 10.666 5.33336V10.1L11.916 8.85002C12.0493 8.71669 12.2078 8.65269 12.3913 8.65802C12.5749 8.66336 12.7331 8.73291 12.866 8.86669C12.9882 9.00002 13.0522 9.15558 13.058 9.33336C13.0638 9.51113 12.9998 9.66669 12.866 9.80002L10.466 12.2C10.3993 12.2667 10.3271 12.314 10.2493 12.342C10.1716 12.37 10.0882 12.3838 9.99935 12.3834ZM5.99935 15.3334C5.63268 15.3334 5.3189 15.2029 5.05802 14.942C4.79713 14.6811 4.66646 14.3671 4.66602 14V12.6667C4.66602 12.4778 4.73002 12.3196 4.85802 12.192C4.98602 12.0645 5.14424 12.0005 5.33268 12C5.52113 11.9996 5.67957 12.0636 5.80802 12.192C5.93646 12.3205 6.00024 12.4787 5.99935 12.6667V14H13.9993V12.6667C13.9993 12.4778 14.0633 12.3196 14.1913 12.192C14.3193 12.0645 14.4776 12.0005 14.666 12C14.8545 11.9996 15.0129 12.0636 15.1413 12.192C15.2698 12.3205 15.3336 12.4787 15.3327 12.6667V14C15.3327 14.3667 15.2022 14.6807 14.9413 14.942C14.6805 15.2034 14.3665 15.3338 13.9993 15.3334H5.99935Z" fill="#98A2B3"/>
                </svg>
              </SoftButton>
              <a
                ref={downloadButton}
                href={url}
                download={`${metadata.customerName} - ${
                  metadata.title ?? metadata.description
                }.jpg`}
                rel="noopener noreferrer"
                target="_blank"
                hidden
              >
                Download
              </a>
            </SoftBox>
          </SoftBox>

          {/* Comments Section */}
          {toggleComment ? (
              <div 
                className="flex-auto"
                style={{
                  background: "#F4F4F4",
                  borderRadius: "8px",
                  padding: "0.5rem",
                }}
              >
                <SoftBox sx={{ display: "flex", alignItems: "center", justifyContent: "end"}}>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setToggleComment(!toggleComment)} style={{ cursor: "pointer", marginBottom: "0.5rem" }}>
                    <rect x="0.198348" y="0.198348" width="17.6033" height="17.6033" rx="5.83478" stroke="#98A2B3" strokeWidth="0.396696"/>
                    <path d="M12.0503 5.10803C12.2826 4.8757 12.6587 4.87582 12.8911 5.10803C13.1235 5.34041 13.1235 5.71646 12.8911 5.94885L9.83936 8.99963L12.8911 12.0514C13.1231 12.2838 13.1234 12.6599 12.8911 12.8922C12.6588 13.1243 12.2826 13.1242 12.0503 12.8922L8.99951 9.84045L5.94873 12.8922C5.71632 13.1241 5.3401 13.1244 5.10791 12.8922C4.87573 12.66 4.87611 12.2838 5.10791 12.0514L8.15869 8.99963L5.10791 5.94885C4.87578 5.71646 4.87565 5.34034 5.10791 5.10803C5.34021 4.87571 5.71634 4.87585 5.94873 5.10803L8.99951 8.15881L12.0503 5.10803Z" fill="#3D3D3F"/>
                  </svg>
                </SoftBox>
                <CommentList
                  comments={comments}
                  currentUser={currentUser}
                  jobId={job._id}
                  onAddComment={onAddComment}
                  onToggleFavorite={onReactToggle}
                  onEditComment={onEditComment}
                  onDeleteComment={onDeleteComment}
                />
              </div>
          ) : null}
        </Grid>
        <Grid item mini={12} md={isModal ? 12 : 4} lg={isModal ? 12 : 4}>
          <SoftBox sx={{ width: "100%", height: toggleComment ? "80%" : "100%" }}>
            {settings.photo && (
              <>
                {images.length ? (
                  <SoftBox sx={{ position: "relative", height: "100%" }}>
                    <Box
                      sx={{
                        width: "100%",
                        height: "98%",
                      }}
                    >
                      <ImageCarousel
                        images={images}
                        labels={labels}
                        height={height}
                      />
                    </Box>
                    {/* Map badge sits in this photo's own corner instead of a
                        viewport-relative offset, so it can never drift onto the
                        placeholder card when there's no photo (see below). */}
                    {location && settings.locationPin && (
                      <SoftBox
                        sx={{
                          position: "absolute",
                          top: "0.75rem",
                          right: "0.75rem",
                          zIndex: 1,
                          borderRadius: "50%",
                          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        <iframe
                          title={location}
                          frameBorder="0"
                          referrerPolicy="no-referrer-when-downgrade"
                          src={`${GOOGLE_MAP_EMBED_API}${encodeURIComponent(location)}`}
                          style={{
                            width: "72px",
                            height: "72px",
                            borderRadius: "50%",
                            borderWidth: "2px",
                            borderStyle: "solid",
                            borderColor: "#1C84CF99",
                            display: "block",
                          }}
                        />
                      </SoftBox>
                    )}
                    {isOwner && (
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setShowGallery(true)} 
                      style={{ 
                        cursor: 'pointer',
                        position: 'absolute',
                        zIndex: 1,
                        left: '2rem',
                        bottom: '2rem',
                      }}>
                        <circle cx="20" cy="20" r="20" fill="#0C0B0B" fillOpacity="0.7"/>
                        <g clipPath="url(#clip0_249_17221)">
                        <path d="M26.2919 19.7747L20.1652 25.9014C19.4147 26.652 18.3967 27.0736 17.3352 27.0736C16.2738 27.0736 15.2558 26.652 14.5052 25.9014C13.7547 25.1508 13.333 24.1329 13.333 23.0714C13.333 22.0099 13.7547 20.992 14.5052 20.2414L20.6319 14.1147C21.1323 13.6144 21.8109 13.3333 22.5186 13.3333C23.2262 13.3333 23.9049 13.6144 24.4052 14.1147C24.9056 14.6151 25.1867 15.2938 25.1867 16.0014C25.1867 16.709 24.9056 17.3877 24.4052 17.8881L18.2719 24.0147C18.148 24.1386 18.001 24.2369 17.8391 24.3039C17.6772 24.371 17.5038 24.4055 17.3286 24.4055C17.1534 24.4055 16.9799 24.371 16.818 24.3039C16.6562 24.2369 16.5091 24.1386 16.3852 24.0147C16.2614 23.8909 16.1631 23.7438 16.096 23.5819C16.029 23.4201 15.9945 23.2466 15.9945 23.0714C15.9945 22.8962 16.029 22.7227 16.096 22.5609C16.1631 22.399 16.2614 22.2519 16.3852 22.1281L22.0452 16.4747" stroke="#FFFCFC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_249_17221">
                        <rect width="16" height="16" fill="white" transform="translate(12 12)"/>
                        </clipPath>
                        </defs>
                      </svg>
                    )}
                    {isOwner && (
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                        style={{ 
                        cursor: 'pointer',
                        position: 'absolute',
                        zIndex: 1,
                        right: '2rem',
                        bottom: '2rem',
                      }}>
                        <circle cx="20" cy="20" r="20" fill="#0C0B0B" fillOpacity="0.7"/>
                        <path d="M17.5002 14.1667L23.3335 20.0001L17.5002 25.8334" stroke="#FDFDFD" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </SoftBox>
                ) : (
                  <SoftBox sx={{ position: "relative", height: "100%" }}>
                    <Stack
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                      spacing={2}
                      sx={{
                        background: "#F9FAFB",
                        borderRadius: "8px",
                        height: {
                          mini: isModal || isMobile ? "180px" : "390px",
                          md: isModal || isMobile ? "180px" : "100%",
                          lg: "100%",
                        },
                      }}
                    >
                      {/* Map now sits inline, above the placeholder copy, instead of
                          floating absolutely — it previously used a viewport-relative
                          offset meant for the photo view and drifted on top of this
                          text whenever a job had no photo. */}
                      {location && settings.locationPin && (
                        <iframe
                          title={location}
                          frameBorder="0"
                          referrerPolicy="no-referrer-when-downgrade"
                          src={`${GOOGLE_MAP_EMBED_API}${encodeURIComponent(location)}`}
                          style={{
                            width: "72px",
                            height: "72px",
                            borderRadius: "50%",
                            borderWidth: "2px",
                            borderStyle: "solid",
                            borderColor: "#1C84CF99",
                            display: "block",
                          }}
                        />
                      )}
                      {isOwner && !isModal ? (
                        <>
                          <Typography
                            sx={{
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '14px',
                              lineHeight: '120%',
                              color: '#98A2B3',
                            }}
                          >
                            No Image Available
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: '16px',
                              lineHeight: '120%',
                              color: '#667085',
                              display: 'flex',
                              cursor: 'pointer',
                            }}
                            onClick={() => setShowGallery(true)}
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '0.5rem' }}>
                              <path d="M7 12V3.85L4.4 6.45L3 5L8 0L13 5L11.6 6.45L9 3.85V12H7ZM2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196666 15.0217 0.000666667 14.5507 0 14V11H2V14H14V11H16V14C16 14.55 15.8043 15.021 15.413 15.413C15.0217 15.805 14.5507 16.0007 14 16H2Z" fill="#667085"/>
                            </svg>
                            Upload Image Now
                          </Typography>
                          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setShowGallery(true)}
                          style={{
                            cursor: 'pointer',
                            position: 'absolute',
                            zIndex: 1,
                            left: '2rem',
                            bottom: '2rem',
                          }}>
                            <circle cx="20" cy="20" r="20" fill="#0C0B0B" fillOpacity="0.7"/>
                            <g clipPath="url(#clip0_249_17221)">
                            <path d="M26.2919 19.7747L20.1652 25.9014C19.4147 26.652 18.3967 27.0736 17.3352 27.0736C16.2738 27.0736 15.2558 26.652 14.5052 25.9014C13.7547 25.1508 13.333 24.1329 13.333 23.0714C13.333 22.0099 13.7547 20.992 14.5052 20.2414L20.6319 14.1147C21.1323 13.6144 21.8109 13.3333 22.5186 13.3333C23.2262 13.3333 23.9049 13.6144 24.4052 14.1147C24.9056 14.6151 25.1867 15.2938 25.1867 16.0014C25.1867 16.709 24.9056 17.3877 24.4052 17.8881L18.2719 24.0147C18.148 24.1386 18.001 24.2369 17.8391 24.3039C17.6772 24.371 17.5038 24.4055 17.3286 24.4055C17.1534 24.4055 16.9799 24.371 16.818 24.3039C16.6562 24.2369 16.5091 24.1386 16.3852 24.0147C16.2614 23.8909 16.1631 23.7438 16.096 23.5819C16.029 23.4201 15.9945 23.2466 15.9945 23.0714C15.9945 22.8962 16.029 22.7227 16.096 22.5609C16.1631 22.399 16.2614 22.2519 16.3852 22.1281L22.0452 16.4747" stroke="#FFFCFC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_249_17221">
                            <rect width="16" height="16" fill="white" transform="translate(12 12)"/>
                            </clipPath>
                            </defs>
                          </svg>
                        </>
                      ) : (
                        <Typography
                          sx={{
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '120%',
                            color: '#98A2B3',
                          }}
                        >
                          No image available
                        </Typography>
                      )}
                    </Stack>
                  </SoftBox>
                  )}
                {isOwner && (
                  <FeedGallery
                    jobId={job._id}
                    images={job.images}
                    open={showGallery}
                    setGallery={setGallery}
                    gallery={gallery}
                    exit={() => setShowGallery(false)}
                  />
                )}
              </>
            )}
          </SoftBox>
        </Grid>
      </Grid>

      <Divider
        sx={{ marginBottom: 2, marginTop: 2 }}
        className="job-details-sm-display"
      />

      {/* Visible on desktop version only */}
      {/* <div className="grid grid-cols-3 grid-rows-[max-content_max-content] gap-y-[1rem] justify-items-start sm:grid-cols-3 sm:gap-x-[1rem] sm:gap-y-[0rem] job-details-sm-hide">
        <div>
          <p className="text-lg sm:text-xl md:text-2xl font-bold">
            {metadata.customerName}
          </p>
          <Typography
            className="!text-base sm:!text-lg md:!text-xl !font-semibold"
            sx={{ color: "primary.main" }}
          >
            {metadata.title || metadata.description}
          </Typography>
          <div className="flex gap-x-[1rem]">
            <div>
              <p className="text-sm sm:text-base md:text-lg font-semibold text-[#787878]">
                Job Total
              </p>
              <p className="text-xs sm:text-sm md:text-base text-[#787878]">
                {formatCurrency(jobTotal || metadata.total)}
              </p>
            </div>
            <div>
              <p className="text-sm sm:text-base md:text-lg font-semibold text-[#787878]">
                Time
              </p>
              <p className="text-xs sm:text-sm md:text-base text-[#787878]">
                {metadata.duration != null
                  ? new Date(metadata.duration * 1000).toISOString().substring(11, 16)
                  : "—"}
              </p>
            </div>
          </div>
        </div>
        <div className="justify-self-center">
          <div className="flex gap-x-[1rem] md:gap-x-[3rem] px-[1rem] py-[0.5rem] justify-center ">
            <SlowClap
              jobId={job._id}
              currentUserId={currentUser._id}
              reacts={reacts}
              onToggle={onReactToggle}
              showDetails={true}
            />

            <div className="flex gap-x-[0.5rem] pt-[0.5rem]">
              <CommentIcon onClick={() => setToggleComment(!toggleComment)} />
              <p className="text-xs sm:text-sm md:text-base font-semibold">
                {comments.length}
              </p>
            </div>
          </div>
        </div>
        <div className="social-share"> */}
      {/* <JobFeedMetaData image={url !== "none" ? url : undefined} /> */}
      {/* <Typography
            className="!text-base sm:!text-lg md:!text-xl !font-semibold"
            sx={{ marginBottom: 1 }}
          >
            Share:
          </Typography>
          <FacebookShareButton
            style={{ marginRight: 5 }}
            ref={shareButton}
            openShareDialogOnClick={url !== "none"}
            url={url}
            onClick={onClick}
            disabled={!gallery.length || !isOwner}
          >
            <FacebookIcon round size={32} />
          </FacebookShareButton>
          <LinkedinShareButton
            style={{ marginRight: 5 }}
            ref={shareButtonLinkedIn}
            openShareDialogOnClick={urlLinkedIn !== "none"}
            url={urlLinkedIn}
            onClick={onClickLinkedIn}
            disabled={!gallery.length || !isOwner}
          >
            <LinkedinIcon round size={32} />
          </LinkedinShareButton>
        </div>
      </div> */}

      <Divider
        sx={{ marginBottom: 2, marginTop: 2 }}
        className="job-details-sm-display"
      />

      {toggleShare ? (
        <>
          <Divider sx={{ marginBottom: 1, marginTop: 0 }} />
          <Typography
            className="!text-base sm:!text-lg md:!text-xl !font-semibold text-center"
            sx={{ marginBottom: 1 }}
          >
            Share:
          </Typography>
          <div className="flex justify-center">
            <FacebookShareButton
              style={{ marginRight: 5 }}
              ref={shareButtonFacebook}
              openShareDialogOnClick={url !== "none"}
              url={url}
              onClick={onClick}
              disabled={!gallery.length || !isOwner}
            >
              <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_166_8040)">
                <path d="M6.07711 3.78064C6.07711 3.67467 6.09183 3.4458 6.12126 3.09552C6.1529 2.74449 6.28537 2.37728 6.52306 1.99167C6.75855 1.60753 7.14048 1.26239 7.6718 0.956993C8.20091 0.653067 8.96551 0.5 9.96339 0.5H12.7745V3.56355H10.7162C10.5124 3.56355 10.3225 3.64008 10.151 3.79094C9.98105 3.9418 9.89348 4.0853 9.89348 4.2185V6.12448H12.7738C12.7436 6.49758 12.7105 6.86037 12.6722 7.21066L12.5582 8.13642C12.5125 8.44918 12.4662 8.73912 12.4206 9.00626H9.87287V17.5H6.07711V9.00552H4.22559V6.12448H6.07711V3.78064Z" fill="black"/>
                </g>
                <defs>
                <clipPath id="clip0_166_8040">
                <rect width="17" height="17" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
                </defs>
              </svg>
            </FacebookShareButton>
            <LinkedinShareButton
              style={{ marginRight: 5 }}
              ref={shareButtonLinkedIn}
              openShareDialogOnClick={urlLinkedIn !== "none"}
              url={urlLinkedIn}
              onClick={onClickLinkedIn}
              disabled={!gallery.length || !isOwner}
            >
              <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.26585 0.511719C1.01739 0.511719 0.000914098 1.528 0 2.77744C0 4.02688 1.01648 5.04336 2.26585 5.04336C3.51477 5.04336 4.53073 4.02688 4.53073 2.77744C4.53073 1.52813 3.51471 0.511719 2.26585 0.511719Z" fill="black"/>
                <path d="M3.96636 5.9541H0.565006C0.403211 5.9541 0.271973 6.08527 0.271973 6.2472V17.1952C0.271973 17.357 0.403211 17.4882 0.565006 17.4882H3.9663C4.12816 17.4882 4.2594 17.357 4.2594 17.1952V6.2472C4.25946 6.08521 4.12822 5.9541 3.96636 5.9541Z" fill="black"/>
                <path d="M12.6621 5.8252C11.4174 5.8252 10.3236 6.20422 9.65607 6.82228V6.24718C9.65607 6.08526 9.52483 5.95408 9.36297 5.95408H6.10023C5.93837 5.95408 5.80713 6.08526 5.80713 6.24718V17.1951C5.80713 17.357 5.93837 17.4882 6.10023 17.4882H9.49832C9.66018 17.4882 9.79142 17.3569 9.79142 17.1951V11.7786C9.79142 10.2246 10.0773 9.26129 11.5039 9.26129C12.9093 9.26299 13.0145 10.2959 13.0145 11.8715V17.1951C13.0145 17.357 13.1458 17.4882 13.3077 17.4882H16.7074C16.8691 17.4882 17.0004 17.3569 17.0004 17.1951V11.1897C17.0003 8.69207 16.5072 5.8252 12.6621 5.8252Z" fill="black"/>
              </svg>
            </LinkedinShareButton>
          </div>
        </>
      ) : null}
    </SoftBox>
  );
}
